export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "trade_code": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trade Code"])}
        },
        "name_en": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name (English)"])}
        },
        "name_fr": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name (French)"])}
        },
        "details": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Details"])},
        "program_standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Program Standards"])},
        "tracking_options": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tracking Options"])},
          "guide_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select the tracking options to be included in logbooks for this training program"])},
          "guide_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["At least one option must be selected."])}
        },
        "program_hours": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Program Hours"])},
          "guide_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter the number of hours a candidate must complete. If this is not relevant to the program, leave blank."])},
          "total_hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total Program Hours:"])}
        },
        "hours_tracking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hours tracking"])},
        "skills_tracking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skills tracking"])},
        "job_hours": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["On-the-job"])}
        },
        "class_hours": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In-class"])}
        },
        "completion_requirements": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logbook Completion Requirements"])},
          "guide_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select the criteria a candidate must meet before their logbook can be approved. At least one option must be selected."])}
        },
        "mandatory_skills": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All mandatory skills are approved"])},
        "program_hours_confirmed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All program hours are credited or confirmed (candidate has met or exceeded the Total Program Hours)"])},
        "confirm_delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete this training program"])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
        "delete_program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Submit"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cannot save: see error messages above"])},
        "error_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This field"])}
      },
      "fr": {
        "trade_code": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code du métier"])}
        },
        "name_en": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom (Anglais)"])}
        },
        "name_fr": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom (Français)"])}
        },
        "details": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Détails"])},
        "program_standards": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Normes du Programme"])},
        "tracking_options": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Options de suivi"])},
          "guide_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner les options de suivi à inclure dans le jour.nal de bord de ce programme de formation"])},
          "guide_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Au moins une option doit être sélectionnée."])}
        },
        "program_hours": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heures du Programme"])},
          "guide_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrer le nombre d’heures qu’un candidat doit compléter. Si ce n’est pas pertinent au programme, laisser à 0."])},
          "total_hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heures totales du programme:"])}
        },
        "hours_tracking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivi des heures"])},
        "skills_tracking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivi de compétences"])},
        "job_hours": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heures au travail"])}
        },
        "class_hours": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heures en classe"])}
        },
        "completion_requirements": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les exigences d’achèvement du journal de bord"])},
          "guide_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner le critère qu’un candidat doit atteindre avant que son journal soit approuvé."])}
        },
        "mandatory_skills": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toutes les compétences obligatoires sont approuvées."])},
        "program_hours_confirmed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toutes les heures du programme sont créditées ou confirmées ( Le candidat a atteint ou excédé le total des heures du programme)"])},
        "confirm_delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Êtes-vous sûr de vouloir supprimer ce programme de formation"])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer"])},
        "delete_program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soumettre"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de sauver: voyez les messages d'erreur ci-dessus"])},
        "error_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le champ"])}
      }
    }
  })
}